/*
Akhila  10/28/2022 3075154998 data manager ux changes
*/

import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddDataManager from './AddDataManager/index';
import SearchDataManager from './SearchDataManager/index';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs({}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [code, setCode] = useState('');
  const [mediaName, setMediaName] = useState('');


  return (
    <div className={classes.root}>
      <div className={classes.searchRuleButton}>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 && (
          <SearchDataManager
            setTabValue={setValue}
            setCode={setCode}
            setMediaName={setMediaName}
          />
        )}
        {value === 1 && (
          <AddDataManager
            setTabValue={setValue}
            mediaName={mediaName}
            code={code}
            // handleTabChange={handleChange}
          />
        )}
        {/* {value === 1 && (
          <AddFilterGroup
            setValue={setValue}
          />
        )}
         {value === 2 && (
          <AddFilterGroup
            setValue={setValue}
          />
        )} */}
      </div>
    </div>
  );
}
